export interface UserOption {
  readonly id: number;
  readonly label: string;
}

export const USER_PICKER_ROW_HEIGHT = 57;

export type UserPickerRow =
  | { readonly key: string; readonly kind: 'clear'; readonly label: string }
  | { readonly key: string; readonly kind: 'user'; readonly id: number; readonly label: string };

export const buildUserPickerRows = (
  users: readonly UserOption[],
  clearLabel?: string,
): UserPickerRow[] => {
  const rows: UserPickerRow[] = [];

  if (clearLabel != null && clearLabel.length > 0) {
    rows.push({ key: 'clear', kind: 'clear', label: clearLabel });
  }

  users.forEach((user) => {
    rows.push({ key: `user-${user.id}`, kind: 'user', id: user.id, label: user.label });
  });

  return rows;
};
